import { stringify } from 'query-string';
import { amplitudeTracker } from '../amplitude-tracker';
import config from '../../../config';

const DEFAULT_ERROR = {
    'message' : 'Server unavailable. Please check your connection and try again.'
};

class ApiClient {
    constructor({prefix = 'v1/'} = {}) {
        this.prefix = prefix;
    }

    async get({url, params, isCheckAccessToken = true, token = null}) {
        return this.request({
            url,
            params,
            method: 'GET',
            isCheckAccessToken,
            token
        });
    }

    async post({url, body = {}, isCheckAccessToken = true, token = null}) {
        return this.request({
            url,
            method: 'POST',
            body,
            isCheckAccessToken,
            token
        });
    }

    async put({url, body = {}, params = {}, isCheckAccessToken = true}) {
        return this.request({
            url,
            method : 'PUT',
            body,
            isCheckAccessToken,
            params
        });
    }

    async patch({url, body = {}, isCheckAccessToken = true}) {
        return this.request({
            url,
            method : 'PATCH',
            body,
            isCheckAccessToken
        });
    }

    async delete({url, body = {}, isCheckAccessToken = true}) {    
        return this.request({
            url,
            method : 'DELETE',
            body,
            isCheckAccessToken
        });
    }

    getHeaders(method, token) {
        const headers = method !== 'GET' ? {'Content-Type': 'application/json'} : {};
        const transactionId = window.crypto?.randomUUID?.();
        const deviceId = amplitudeTracker.getDeviceId();

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }

        if (transactionId) {
            headers['X-Transaction-Id'] = transactionId;
        }

        if (deviceId) {
            headers['X-Device-Id'] = deviceId;
        }

        return headers;
    }

    async getJsonFromResponse(response) { /* for 201 status code */
        try {
            const json = await response.json();

            return json;
        } catch (e) {
            return {};
        }
    }

    async request({url, method, params = {}, body, token}) {
        const query = Object.keys(params).length ? `?${stringify(params)}` : '';
        const options = {
            method,
            headers: this.getHeaders(method, token),
            credentials: 'include',
            body: body ? JSON.stringify(body) : undefined
        };
        const fullUrl = `${config.apiUrl}${this.prefix}${url}`;
        const response = await fetch(`${fullUrl}${query}`, options);

        if (response.status >= 500) throw DEFAULT_ERROR;

        if (response.status === 204 || response.status === 202) return {};

        const json = await this.getJsonFromResponse(response);

        if (response.status >= 400) {
            if (response.status === 401) {
                throw {message: 'Unauthorized: status - 401'};
            }
    
            if (response.status === 429) {
                throw {message: 'Too many requests. Please try again in one minute.'};
            }

            throw json;
        }

        return json;
    }
};

export {
    ApiClient
};
